module.exports = __webpack_public_path__ + "img/body.bfdb38c.svg";